import React from "react";
import { NoteSelectionGroup } from "../utils/NoteSelectionGroup";
import { RydCollapsableCard } from "./widgets/RydCollapsableCard";
import { normalizeClassName } from "../render/renderUtils";
import { RydFeatures } from "../utils/FeatureToggle";
import { findMatchingScales } from "../services/ScaleIdentifyier";
import { ScalesService } from "../services/ScalesService";


const unique = (v, i, a) => a.indexOf(v) === i;

export function RydSelectedNotesInfobox({
    noteSelectionGroups,
}: {
    noteSelectionGroups: Map<number, NoteSelectionGroup>;
}) {
    const uniqueTones = Array.from(noteSelectionGroups.values())
        .map(g => g.getUniqueNotes().map(n => n.getTone()))
        .flat()
        .filter(unique);
    const matchingScales = findMatchingScales(ScalesService.listPatterns().map(sp => sp.pattern), uniqueTones);

    return (<>
        <RydCollapsableCard title="Selection" >
            <ul className={normalizeClassName(['midi-device-panel--list', 'ryd-list--horizontal'])}>
                {uniqueTones.map((n, i) => (
                    <li key={i}>
                        {n.getName()}
                    </li>
                ))}
            </ul>
        </RydCollapsableCard>

        <RydCollapsableCard title="Matching scales" >
            <table>
                <tbody>
                    {matchingScales.map((s, i) => (
                        <tr key={i}>
                            <td>{s.name}</td>
                            <td>{s.pattern.pattern.intervals}</td>

                            {s.tones.map((d, j) => (
                                <td key={j}>{d.getName()}</td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </RydCollapsableCard>

        {RydFeatures.Toggle.isOn('CHORD_INSPECTOR') &&
            <RydCollapsableCard title="Matching chords" >
                chords matching the selection will be displayed here.
            </RydCollapsableCard>
        }
    </>);
}
